import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ValidatedField from 'components/controls/validated-field';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { translationApi  } from 'actions/translation-api';
import { changeSearchCriteria, changeClient } from 'store/client/slice.account-list-filter';
import { tryParseInt } from 'utils/number-utils';

const ClientAccountSearchFilter = () => {
    const dispatch = useDispatch();
    const params = useParams();
	const clientIdString = params.id;
	const clientId = tryParseInt(clientIdString);
    const clientPreSelected = clientId !== null;

    const [submitEnabled, setSubmitEnabled] = useState(true);
	const accountListFilter = useSelector(state => state.accountListFilter);
    const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const filterForCurrentClient = (isNaN(clientId) && isNaN(accountListFilter.filterForClient)) || clientId === accountListFilter.filterForClient;
	if (!filterForCurrentClient) {
		dispatch(changeClient(clientId));
	}

    const handleSubmit = fields => {
        const filter = {
            clientId: tryParseInt(fields?.clientId),
            clientName: fields?.clientName,
            clientVatin: fields?.clientVatin,
            firstName: fields?.firstName,
            lastName: fields?.lastName,
            email: fields?.email,
            page: 1,
        };
        dispatch(changeSearchCriteria(filter));

        setSubmitEnabled(false);
        setTimeout(() => setSubmitEnabled(true), 1000);
    };

    const validationSchema = Yup.object().shape({
        clientId: Yup.number(),
        clientName: Yup.string(),
        clientVatin: Yup.string()
            .max(10, translations.warningValueTooLong),
        firstName: Yup.string(),
        lastName: Yup.string(),
        email: Yup.string()
    });

    const initialValues = {
        clientId: filterForCurrentClient ? accountListFilter?.clientId?.toString().padStart(4, '0') ?? "" : clientPreSelected ? clientId : "",
        clientName: filterForCurrentClient ? accountListFilter?.clientName ?? "" : "",
        clientVatin: filterForCurrentClient ? accountListFilter?.clientVatin ?? "" : "",
        firstName: filterForCurrentClient ? accountListFilter?.firstName ?? "" : "",
        lastName: filterForCurrentClient ? accountListFilter?.lastName ?? "" : "",
        email: filterForCurrentClient ? accountListFilter?.email ?? "" : ""
    };

    const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={fields => { handleSubmit(fields) }}>
            {props => (
                <Form autoComplete={randomAutoComplete}>
                    <div className="col-12 mb-4">
                        <div className="card border-light shadow-sm">
                            <div className="card-body">
                                <h2 className="h6 mb-2">{translations.filters}</h2>
                                {!clientPreSelected &&
                                    <div className="row">
                                        <div className="col-lg-2 col-md-12 mb-2">
                                            <ValidatedField name="clientId" placeholder={translations.clientNumberShort} maxLength="4" {...props} />
                                        </div>
                                        <div className="col-lg-2 col-md-12 mb-2">
                                            <ValidatedField name="clientName" placeholder={translations.clientName} {...props} />
                                        </div>
                                        <div className="col-lg-2 col-md-12 mb-2">
                                            <ValidatedField name="clientVatin" placeholder={translations.clientVATIN} maxLength="10" {...props} />
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    {clientPreSelected &&
                                        <Field name="clientId" type="hidden" />
                                    }
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedField name="firstName" placeholder={translations.firstName} {...props} />
                                    </div>
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedField name="lastName" placeholder={translations.lastName} {...props} />
                                    </div>
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedField name="email" placeholder={translations.email} {...props} />
                                    </div>
                                    <div className="col mb-2">
                                        <button id="searchButton" type="submit" className="btn btn-secondary float-end" disabled={submitEnabled ? null : 'disabled'} ><FontAwesomeIcon icon={faSearch} className="me-2" />{translations.actionSearch}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>)}
        </Formik>
    )
}

export default ClientAccountSearchFilter;
